import { useSearchParams } from "react-router-dom";
import { DocumentRecords } from "@components/Records/DocumentRecords";
import { APPostingsPage } from "./APPostingsPage";
import { useRecordTypes } from "@/lib/recordCatalog";
import { OpenApprovalList } from "@components/Approvals/OpenApprovalList";
import type { OpenApprovalRequest } from "@schemas/api";

export function ApprovalsPage() {
  const [params, setParams] = useSearchParams();
  const types = useRecordTypes().filter((t) => t.id !== "vendor");
  const selected = params.get("type") ?? "all";
  const allowed =
    selected === "all"
      ? types.length > 0
      : types.some((t) => t.id === selected);
  const has = (id: string) => types.some((t) => t.id === id);
  const documents =
    selected === "all"
      ? undefined
      : selected === "invoice" ||
          selected === "receipt" ||
          selected === "purchase_order"
        ? selected
        : null;
  const reviewing =
    (documents !== null && params.has("document_id")) ||
    (selected === "ap_posting" && params.has("posting_id"));
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold text-content-primary">
          Approvals
        </h1>
        <p className="text-content-secondary">
          Review pending invoices, receipts, purchase orders and AP postings.
        </p>
      </header>
      <nav aria-label="Approval types" className="flex flex-wrap gap-2">
        {[{ id: "all", label: "All approvals" }, ...types].map((t) => (
          <button
            key={t.id}
            type="button"
            aria-pressed={selected === t.id}
            className={`rounded-lg border px-4 py-2 text-sm ${selected === t.id ? "border-primary-500 bg-primary-50 text-primary-700" : "border-border-default text-content-secondary"}`}
            onClick={() => setParams({ type: t.id })}
          >
            {t.label}
          </button>
        ))}
      </nav>
      {!allowed ? (
        <p role="status">
          No approval types are available for your permissions or plan.
        </p>
      ) : !reviewing ? (
        <OpenApprovalList
          key={selected}
          recordType={
            selected === "all"
              ? undefined
              : (selected as OpenApprovalRequest["record_type"])
          }
        />
      ) : (
        <div key={selected} className="space-y-8">
          <button
            type="button"
            className="text-sm font-medium text-primary-600 underline"
            onClick={() => setParams({ type: selected })}
          >
            Back to approval requests
          </button>
          {documents !== null && has("invoice") && (
            <DocumentRecords documentType={documents} approvalOnly />
          )}
          {selected === "ap_posting" && has("ap_posting") && (
            <APPostingsPage approvalOnly />
          )}
        </div>
      )}
    </div>
  );
}
